export const positionStatuses = {
    DRAFT: 'Draft',
    READY: 'Ready',
    ACTIVE: 'Active',
    DONE: 'Done',
    CANCELLED: 'Cancelled',
    FINISHED: 'Finished',
};
